var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"No sections yet...\" grid-title=\"Sections\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.sections\" create-method=\"vm.addMenuSection\" update-method=\"\" delete-method=\"removeSection\" add-toggle=\"vm.addMenuSection\" fields=\"{\n                title: {input: 'text', header: 'Section Title', order: 10, width: 20, type: 'string'}, \n                subtitle: {input: 'textarea', header: 'Subtitle', order: 20, width: 30, type: 'string'},\n                footer: {input: 'textarea', header: 'Footer', order: 30, width: 30, type: 'string'}\n                }\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/menus/tabs/tab-sections2.jade
// module id = 199
// module chunks = 0